import React, { Component } from 'react';
import { Redirect, Route } from 'react-router-dom';
import queryString from 'query-string';
import { appService } from '../../_services';
import { Maintenance } from '../Maintenance/Maintenance.jsx';
let RedirectURL = '', url = '', params = '';

export class DefaultUrlRedirect extends Component {
    constructor(props) {
        super(props);
        this.state = { IsError: false }
    }

    async renderRedirect() {
        var self = this;
        var code = '';
        var area = '';
        var values = '';

        url = this.props.location.search;
        url = url.replace(/&amp;/g, '&');
        params = queryString.parse(url);

        if (params.requested) {
            code = params.requested.split("id=").pop();
        }
        else if (params.id) {
            code = params.id;
        }
        else if (params.pubcode) {
            code = params.pubcode;
        }
        if (params.area) {
            area = params.area;
        }
        if (params.values) {
            values = params.values;
        }
        if (this.props.location.pathname != "") {
            code = this.props.location.pathname.replace("/", "");
        }
        if (values != "") {
            await appService.getById('Product/GetURLToc?values=', values)
                .then(function (data) {
                    if (data.isErrorExist == true) {
                        self.setState({ IsError: true });
                    }
                    else {
                        self.RedirectURL = '';
                        if (data.issueNo != 0) {
                            RedirectURL = "/journalIssue/" + data.title + "/" + data.volumeNo + "." + data.issueTextNo + "/" + data.issueId;
                        }
                        else if (area == "Journals" && data.productTypeId == 1) {
                            RedirectURL = "/Journals/" + data.title + "/" + data.prodId;
                        }
                        else if (data.productTypeId == 2) {
                            RedirectURL = "/Manuals/" + data.title + "/" + data.prodId;
                        }
                        else if (data.productTypeId == 3) {
                            RedirectURL = "/Encyclopedias/" + data.title + "/" + data.prodId;
                        }
                    }
                });
            if (RedirectURL != '') {
                window.location.href = RedirectURL;
            }
        }
        //RedirectURL = params.values.split('~~')[1];
        //alert(area);
        else if (code != "") {
            await appService.getById('Product/GetURLParameters?code=', code)
                .then(function (data) {

                    if (data.isErrorExist == true) {
                        const metaRobots = document.createElement('meta');
                        metaRobots.name = 'robots';
                        metaRobots.content = 'noindex';
                        document.head.appendChild(metaRobots);
                        self.setState({ IsError: true });
                    }
                    else {
                       
                        self.RedirectURL = '';
                        if (data.productTypeId == 1 && data.prodDetailId == 0) {
                            RedirectURL = "/Journals/" + data.title + "/" + data.prodId;
                        }
                        //else if (area == "Journals" && data.productTypeId == 1) {
                        //    RedirectURL = "/Journals/" + data.title + "/" + data.prodId;
                        //}
                        //else if (area == "Looseleafs" && data.productTypeId == 2) {
                        //    RedirectURL = "/Manuals/" + data.title + "/" + data.prodId;
                        //}
                        //else if (area == "Looseleafs" && data.productTypeId == 3) {
                        //    RedirectURL = "/Encyclopedia/" + data.title + "/" + data.prodId;
                        //}
                        else if (data.productTypeId == 2 && data.prodDetailId == 0) {
                            RedirectURL = "/Manuals/" + data.title + "/" + data.prodId;
                        }
                        else if (data.productTypeId == 3 && data.prodDetailId == 0) {
                            RedirectURL = "/Encyclopedias/" + data.title + "/" + data.prodId;
                        }
                        else if (data.productTypeId == 1 && data.prodDetailId > 0) {
                            RedirectURL = "/journalarticle/" + data.title + "/" + data.volumeNo + "." + data.issueTextNo + "/" + data.docId;
                        }
                        else if (data.productTypeId == 2 && data.prodDetailId > 0) {
                            RedirectURL = "/ManualChapter/" + data.title + "/" + data.docId;
                        }
                        else if (data.productTypeId == 3 && data.prodDetailId > 0) {
                            RedirectURL = "/EncyclopediaChapter/" + data.title + "/" + data.docId;
                        }
                    }
                });
            if (RedirectURL != '') {
                window.location.href = RedirectURL;
            }
        }

    }
    render() {
        if (this.state.IsError != true) {
            this.renderRedirect()
        }
        return (
            this.state.IsError != true ?
            <div></div>
                :
                <Maintenance />
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/Maintenance/DefaultUrlRedirect.jsx